module.exports = __webpack_public_path__ + "media/country_flags/tg-e02d1975.png";